<template>
  <b-form-group :label="label" :label-sr-only="noLabel">
    <b-input-group>
      <slot name="prepend"></slot>
      <b-form-file
        v-model="content"
        :state="state"
        @input="handleInput"        
        :disabled="readonly"
        :placeholder="placeholder"
        :lazy="lazy"
        :drop-placeholder="dropPlaceholder"
        browse-text="Selecionar"
      />
      <b-button v-if="file" @click="baixarArquivo" class="ml-2" variant="flat-info">
        <i class="fa-solid fa-cloud-arrow-down"></i>
      </b-button>
      <slot name="append"></slot>
      <b-form-invalid-feedback v-if="!hideFeedback">{{ feedback }}</b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: "InputFile",
  props: {
    stateCustom: { type: Boolean, default: true },
    value: { default: null },
    label: { type: String },
    noLabel: { type: Boolean, default: false },
    required: { type: Boolean },
    requiredMessage: { type: String },
    readonly: { type: Boolean, default: false },
    placeholder: { type: String, default : "Nenhum arquivo selecionado" },
    validate: { type: Boolean, default: null },
    lazy: { type: Boolean, default: false },
    hideFeedback: { type: Boolean, default: false },
    dropPlaceholder: { type: String, default: "Arraste o arquivo" },
  },
  data() {
    return {
      content: this.value,
      file: null,
      validForm: false,
      hasError: false,
      errorMessage: "",
      inputPasswordIcon: "fas fa-eye",
    };
  },
  computed: {
    requiredValid() {
      return !(this.required && (this.content == "" || this.content == null));
    },
    state() {
      if (!this.stateCustom) return false;

      if (!this.validForm) return null;

      if (!this.requiredValid) return false;
      if (this.hasError) return false;
      if (this.validate != null) return this.validate;
      return true;
    },
    feedback() {
      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t("CAMPOS_VALIDACAO.REQUERIDO").formatUnicorn({
            name: this.label,
          })
        );
      
      if (this.hasError) return this.errorMessage;
      return "";
    },
  },
  methods: {
    showError(message) {
      this.validForm = true;
      this.hasError = true;
      this.errorMessage = message;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    baixarArquivo(){
      let arquivo = this.file;
      var a = document.createElement("a");
      a.href = `${arquivo}`;
      let extensao = arquivo.substring(0,arquivo.indexOf(";")).replace("data:application/","");
      a.download = `arquivo.${extensao}`;
      a.click();
    },
    handleInput() {
      this.getBase64(this.content).then((data) => {
        this.file = data;
        this.$emit("input",  data, this.content.name);
        this.hasError = false;
      });
    },
    valid() {
      this.validForm = true;
      return this.state;
    },
    clear() {
      this.content = null;
      this.validForm = false;
      this.$emit("input", this.content);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.file = value;
      },
      deep: true,
      immediate: true,
    },
    /*content(val) {
      this.$emit("input", val);
      this.$emit("change", val);
    },*/
  },
};
</script>
<style>
input[readonly] {
  background-color: #f2f3f8 !important;
}

.custom-file-label::after {
    height: 40px !important;
    line-height: 27px !important;
}

label.custom-file-label {
    height: 40px;
    padding: 10px 10px;
}

</style>
